import React from "react";

import * as FocusContentStyles from "../../../styles/widgets/focus-content.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Embedded } from "./embedded/Embedded";
import { toExternalUrl } from "../../../utils/utils";
import AppButton from "../AppButton";
import { altNN } from "../../../utils/parsing";
import clsx from "clsx";

const FocusContent = ({ title, content, cover, video, playingVideoIndex, setPlayingVideoIndex, playableIndex, link, link_text, new_window }) => {
	return (
		<div className={FocusContentStyles.root}>
			{(cover || video) &&
				<div className={FocusContentStyles.imgcContainer} >
					{cover !== null && <GatsbyImage
						loading="eager"
						image={getImage(cover.imageFile)}
						alt={altNN("")}
						title={cover.name || ""}
						style={{ height: "100%", width: "100%" }}
					/>}
					{cover == null && video !== null && <Embedded
						contentUrl={video}
						playingVideoIndex={playingVideoIndex}
						setPlayingVideoIndex={setPlayingVideoIndex}
						index={playableIndex}
					/>}
				</div>
			}
			<div className={clsx(FocusContentStyles.innerContainer, {[FocusContentStyles.innerContainerNoImg]: !cover && !video})}>
				<p className={FocusContentStyles.title}>
					{title}
				</p>
				<p className={clsx(FocusContentStyles.content, {[FocusContentStyles.contentNoImg]: !cover && !video})}>
					{content}
				</p>
				<AppButton
					color="secondary"
					variant="contained"
					label={link_text}
					tabIndex="0"
					padding={10}
					noBorder
					width="80%"
					id={title}
					onClick={() => {
						typeof new_window !== `undefined` &&
						window.open(toExternalUrl(link), (new_window === true) ? "_blank" : "_self")
					}}
					onKeyDown={() =>
						typeof new_window !== `undefined` &&
						window.open(toExternalUrl(link), (new_window === true) ? "_blank" : "_self")
					}
				>
					<p className={FocusContentStyles.labelButton}>{link_text}</p>
				</AppButton>
			</div>
		</div>
	);
};

export default FocusContent;
